import { Slab } from "react-loading-indicators";
import { useTranslation } from 'react-i18next';
import styles from '../styles/bim.module.scss';

function Loading({ size, progress, background = null, loadedFrames = 0, totalFrames = 0 }) {

    const { t } = useTranslation();

    const backgroundImageUrl = background ? `url(${background})` : null;
    const maxBlur = 20;
    const loadProgress = loadedFrames / totalFrames;
    const calculatedBlur = Math.max(0, (1 - loadProgress) * maxBlur);

    return (
        <div
            className={styles.loading_screen}
            style={{
                backgroundImage: `${background ? backgroundImageUrl : ''}`, 
                backgroundSize: 'cover', 
                backgroundPosition: 'center center',
                width: '100%', 
                height: '100%'
            }}
        >
            {background && totalFrames && (
                <div id="blur"
                    style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        backdropFilter: `blur(${calculatedBlur}px)`,
                    }}
                />
            )}
            <Slab color={`#757575`} size={size} text={`${t('loading')} ${progress ? progress : ''}`} />
        </div>
    )
}

export default Loading;
